import axios from 'axios';

export default {
  uploadFile: params => (
    axios.post(`media_objects`, params)
  ),
  update: (id, params) => (
    axios.post(id, params)
  ),
  delete: id => (
    axios.delete(id)
  )
}


// WEBPACK FOOTER //
// ./src/api/mediaObject.js